import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the patient-data endpoint.
 * Expects a sanitized payload — sanitisation must be performed by the caller.
 */
export function buildPatientDataConfig(payload: Record<string, unknown>): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.PATIENT_DATA,
    body: payload,
  };
}
